import ClubMemberAvatarRow from './ClubMemberAvatarRow';

export default ClubMemberAvatarRow;
